import { useState, useEffect } from 'react';
import api from '../api/client';

const DEFAULTS = { chat: true, forecast: true, suggestions: true, nl_query: true, anomalies: true };

// Module-level cache so all components share one fetch per session
let _cache = null;
let _cacheTime = 0;
const CACHE_TTL = 60_000; // 1 minute

export function useAIFeatures() {
  const [features, setFeatures] = useState(_cache || DEFAULTS);

  useEffect(() => {
    const now = Date.now();
    if (_cache && now - _cacheTime < CACHE_TTL) { setFeatures(_cache); return; }
    api.get('/settings/ai-features')
      .then(r => { _cache = r.data; _cacheTime = Date.now(); setFeatures(r.data); })
      .catch(() => { setFeatures(DEFAULTS); });
  }, []);

  return features;
}

// Call this after admin saves to invalidate the cache
export function invalidateAIFeaturesCache() {
  _cache = null;
  _cacheTime = 0;
}
